export default function SponsorCheckoutModal({ slot, form, setForm, onCancel, onPay, loading }) {
  if (!slot) return null;
  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center px-4 bg-black/80 backdrop-blur-sm"
      onClick={() => !loading && onCancel()}
      data-testid="sponsor-checkout-modal"
    >
      <div
        className="w-full max-w-md border border-[#FF1493]/60 bg-[#141414] p-7 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="overline">Lock in this slot</div>
        <h3 className="font-display text-3xl uppercase mt-2 leading-none drip-shadow">
          {slot.city}, {slot.state}
        </h3>
        <div className="text-xs text-white/60 mt-2">
          {slot.tier} ·{" "}
          {new Date(slot.scheduled_date).toLocaleDateString(undefined, {
            month: "long",
            day: "numeric",
            year: "numeric",
          })}
        </div>
        <div className="font-display text-4xl text-[#FFC107] mt-4">
          ${slot.price.toLocaleString()}
        </div>

        <div className="mt-5 space-y-3">
          <input
            placeholder="Brand / company name *"
            className="tac-input"
            value={form.sponsor_name}
            onChange={(e) => setForm({ ...form, sponsor_name: e.target.value })}
            data-testid="sponsor-checkout-name"
          />
          <input
            type="email"
            placeholder="Contact email *"
            className="tac-input"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="sponsor-checkout-email"
          />
          <input
            placeholder="Website (optional)"
            className="tac-input"
            value={form.website}
            onChange={(e) => setForm({ ...form, website: e.target.value })}
            data-testid="sponsor-checkout-website"
          />
          <textarea
            rows={3}
            placeholder="What do you want featured? (optional)"
            className="tac-input"
            value={form.note}
            onChange={(e) => setForm({ ...form, note: e.target.value })}
            data-testid="sponsor-checkout-note"
          />
        </div>

        <div className="flex items-center gap-3 mt-5">
          <button
            onClick={onCancel}
            disabled={loading}
            className="btn-ghost flex-1 justify-center"
            data-testid="sponsor-checkout-cancel"
          >
            Cancel
          </button>
          <button
            onClick={onPay}
            disabled={loading}
            className="btn-blaze flex-1 justify-center"
            data-testid="sponsor-checkout-pay"
          >
            {loading ? "Loading..." : `Pay $${slot.price.toLocaleString()}`}
          </button>
        </div>
        <div className="text-[10px] font-mono-tactical text-white/40 text-center uppercase tracking-[0.2em] mt-4">
          Secure · Stripe checkout · Slot held for 30 min
        </div>
      </div>
    </div>
  );
}
